import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { UserService } from 'src/app/core/services/user.service';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-sales-home',
  templateUrl: './sales-home.component.html',
  styleUrls: ['./sales-home.component.scss'],
  providers: [DatePipe]
})
export class SalesHomeComponent implements OnInit {
  agencyCode: string;
  agentId: string;
  checkOVRInAgencyCode: any;
  agentIdActive: string;
  leadStatus: any;

  constructor(public user: UserService,private datePipe: DatePipe,private router: Router) { }
  showPolicyDetails:boolean=false;
  showPolicySearch:boolean=true;
  showRefundPolicy:boolean=false;
  showHome: boolean=true;
  leadsId:any;
  ngOnInit(): void {
    localStorage.removeItem('searchCriteria');
    localStorage.removeItem('sortBy');
    localStorage.removeItem('sortType');
    this.checkOVRInAgencyCode=sessionStorage.getItem('checkOVRInAgencyCode');
    this.leadsId=sessionStorage.getItem('leadId');
    this.agencyCode=sessionStorage.getItem('agencyCodeSalesPortal');
    this.agentId=sessionStorage.getItem('agentIdSalesPortal');
    // this.agentIdActive=sessionStorage.getItem('agentIdActive');
    this.getLeadAgentsCodes()
    this.getAllProvinces1()
    window.scrollTo(0, 0);
    this.getDashboard();
    this.getSearchPolicy(event);
  }

  onClickPolicyNumber(id,number){
    // this.showPolicyDetails=true;
    // this.showPolicySearch=false;
    this.showHome=false
    
    
      localStorage.setItem('tlSalesAdminPolicyAdmin',id)
      this.router.navigateByUrl('/dashboard/policy-details');
  }
  backToPolicySearch(){
    this.showHome=true;
    this.showPolicyDetails=false;
    this.showPolicySearch=true;
    this.showRefundPolicy=false;
  }
  onClickRefundPolicy(){
    this.showHome=false
    this.showPolicyDetails=false;
    this.showPolicySearch=false;
    this.showRefundPolicy=true;
  }

effectiveEndDate: any;
effectiveStartDate: any;
effectivePolicyListTotal: any;
expirePolicyListTotal: any;
effectivePolicyList=[];
expirePolicyList=[];
selectedButton="Active"
selectedButton1=""
selectedButton2=""
  getSearchPolicy(event){
    this.selectedButton = "Active";
    this.selectedButton1 = ""
    this.selectedButton2 = ""
    this.effectiveStartDate = new Date();
    const dateTwo = new Date(new Date(this.effectiveStartDate).setDate(this.effectiveStartDate.getDate() + 7));
    this.effectiveEndDate=dateTwo;
    this.effectiveEndDate = this.datePipe.transform(this.effectiveEndDate, "yyyy-MM-dd");
    this.effectiveStartDate = this.datePipe.transform(this.effectiveStartDate, "yyyy-MM-dd");
    // this.user.policySearch(this.effectiveEndDate,this.effectiveStartDate,this.agencyCode).pipe()
    this.user.getPolicyHomePage(this.effectiveEndDate,this.effectiveStartDate,this.agentId).pipe()
    .subscribe(
        data => {
    this.effectivePolicyList = data.data.effectivePolicyList.searchPolicyDetails;
    this.expirePolicyList = data.data.expirePolicyList.searchPolicyDetails;
    if(data.data.effectivePolicyList.total != null){
      this.effectivePolicyListTotal = data.data.effectivePolicyList.total;
    }else{
      this.effectivePolicyListTotal=0
    }
    if(data.data.expirePolicyList.total != null){
      this.expirePolicyListTotal = data.data.expirePolicyList.total

    }else{
      this.expirePolicyListTotal = 0
    }
        },error=>{ 
            },()=>{});
   
  }
  getSearchPolicy14Days(){
    this.selectedButton = ""
    this.selectedButton1 = "Active"
    this.selectedButton2 = ""
    this.effectiveStartDate = new Date();
    const dateTwo = new Date(new Date(this.effectiveStartDate).setDate(this.effectiveStartDate.getDate() + 14));
    this.effectiveEndDate=dateTwo;
    this.effectiveEndDate = this.datePipe.transform(this.effectiveEndDate, "yyyy-MM-dd");
    this.effectiveStartDate = this.datePipe.transform(this.effectiveStartDate, "yyyy-MM-dd");
    // this.user.policySearch(this.effectiveEndDate,this.effectiveStartDate,this.agencyCode).pipe()
    this.user.getPolicyHomePage(this.effectiveEndDate,this.effectiveStartDate,this.agentId).pipe()
    .subscribe(
        data => {
    this.effectivePolicyList = data.data.effectivePolicyList.searchPolicyDetails;
    this.expirePolicyList = data.data.expirePolicyList.searchPolicyDetails;
    if(data.data.effectivePolicyList.total != null){
      this.effectivePolicyListTotal = data.data.effectivePolicyList.total;
    }else{
      this.effectivePolicyListTotal=0
    }
    if(data.data.expirePolicyList.total != null){
      this.expirePolicyListTotal = data.data.expirePolicyList.total

    }else{
      this.expirePolicyListTotal = 0
    }
        },error=>{ 
            },()=>{});
   
  }
  getSearchPolicy30Days(){
    this.selectedButton = ""
    this.selectedButton1 = ""
    this.selectedButton2 = "Active"
    this.effectiveStartDate = new Date();
    const dateTwo = new Date(new Date(this.effectiveStartDate).setDate(this.effectiveStartDate.getDate() + 30));
    this.effectiveEndDate=dateTwo;
    this.effectiveEndDate = this.datePipe.transform(this.effectiveEndDate, "yyyy-MM-dd");
    this.effectiveStartDate = this.datePipe.transform(this.effectiveStartDate, "yyyy-MM-dd");
    // this.user.policySearch(this.effectiveEndDate,this.effectiveStartDate,this.agencyCode).pipe()
    this.user.getPolicyHomePage(this.effectiveEndDate,this.effectiveStartDate,this.agentId).pipe()
    .subscribe(
        data => {
    this.effectivePolicyList = data.data.effectivePolicyList.searchPolicyDetails;
    this.expirePolicyList = data.data.expirePolicyList.searchPolicyDetails;
    if(data.data.effectivePolicyList.total != null){
      this.effectivePolicyListTotal = data.data.effectivePolicyList.total;
    }else{
      this.effectivePolicyListTotal=0
    }
    if(data.data.expirePolicyList.total != null){
      this.expirePolicyListTotal = data.data.expirePolicyList.total

    }else{
      this.expirePolicyListTotal = 0
    }
        },error=>{ 
            },()=>{});
   
  }

  getSearchPolicyManual(){
  this.selectedButton = ""
  this.selectedButton1 = ""
  this.selectedButton2 = ""
    this.effectiveEndDate = this.datePipe.transform(this.effectiveEndDate, "yyyy-MM-dd");
    this.effectiveStartDate = this.datePipe.transform(this.effectiveStartDate, "yyyy-MM-dd");
    // this.user.policySearch(this.effectiveEndDate,this.effectiveStartDate,this.agencyCode).pipe()
    this.user.getPolicyHomePage(this.effectiveEndDate,this.effectiveStartDate,this.agentId).pipe()
    .subscribe(
        data => {
    this.effectivePolicyList = data.data.effectivePolicyList.searchPolicyDetails;
    this.expirePolicyList = data.data.expirePolicyList.searchPolicyDetails;
    if(data.data.effectivePolicyList.total != null){
      this.effectivePolicyListTotal = data.data.effectivePolicyList.total;
    }else{
      this.effectivePolicyListTotal=0
    }
    if(data.data.expirePolicyList.total != null){
      this.expirePolicyListTotal = data.data.expirePolicyList.total

    }else{
      this.expirePolicyListTotal = 0
    }
        },error=>{ 
            },()=>{});
   
  }
  provincesArray1:any=[];
  hideQuotePurchase:any;
  getAllProvinces1(){
    this.user.getProvinceByAgentId(this.agentId).subscribe((data:any) =>{
     this.provincesArray1 = data.data;
     sessionStorage.removeItem('hideQuotePurchase');
     if(data.status==false || data.success==false){
      sessionStorage.setItem('hideQuotePurchase', 'true');
      this.hideQuotePurchase=sessionStorage.getItem('hideQuotePurchase')
     }
    },error=>{{
    }},()=>{});
  }
  isDisabled: boolean = false;
  goToQuotePurchase(){
    //debugger
    if(this.isDisabled){
      return;
    }
    if((this.hideQuotePurchase!="true" && this.agentIdActive=='true')){
      this.router.navigateByUrl('/dashboard/Quotes-Purchase');
    }else{
      if(this.hideQuotePurchase=="true"){
      Swal.fire("","We require your most up-to-date licenses to allow you to sell. Please upload through 'Documents' option under your Account.","info")
    }
    }
  }
  callEffectiveStartDate(){
    this.effectiveStartDate = this.effectiveStartDate._d;
    console.log("EffectiveStartDate!!",this.effectiveStartDate);
  }
  callEffectiveEndDate(){
    this.effectiveEndDate = this.effectiveEndDate._d;
    console.log("EffectiveEndDate!!",this.effectiveEndDate);
  }
  getLeadAgentsCodes(){
    this.user.getLeadAgentsCodes(this.leadsId).pipe()
    .subscribe(
      data => {
      // console.log(data);
      // this.agentcodedata=[];
    ////
      // this.agentIdActive=sessionStorage.getItem('agentIdActive');
      for(let i=0;i<data.data.agentCodes.length;i++){
        if(this.agentId==data.data.agentCodes[i].id){
          if(data.data.agentCodes[i].status=="Active" || data.data.agentCodes[i].status=="Primary")
          {
          this.agentIdActive='true'
          }
          else{
            this.agentIdActive='false'
          }
        }
       // this.agentcodedata.push(data.data.agentCodes[i])
        // console.log(this.agentcodedata)
      }
      }, error => {
  
        // if (error.status == 400 || error.status == 417) {
        //   this.error = error.error.data;
        // }
        // else {
        //   this.error = "Something went wrong. Please check username and password.";
        // }
      }, () => { });
    }
    goToSalesHome(){
      if(this.agentIdActive=='true'){
        this.router.navigateByUrl('/dashboard/sales-home');
      }else{
        // Swal.fire("","We require your most up-to-date licenses to allow you to sell. Please upload through 'Documents' option under your Account.","info")
      }

    }
goToPolicySearch(){
  if(this.agentIdActive=='true'){
    this.router.navigateByUrl('/dashboard/policy-search');
  }else{
    // Swal.fire("","We require your most up-to-date licenses to allow you to sell. Please upload through 'Documents' option under your Account.","info")
  }

}
goToSaveQuote(){
  
  if(this.agentIdActive=='true'){
    this.router.navigateByUrl('/dashboard/Save-Quotes');
  }else{
    // Swal.fire("","We require your most up-to-date licenses to allow you to sell. Please upload through 'Documents' option under your Account.","info")
  }
}
goToforms(){
  
  if(this.agentIdActive=='true'){
    this.router.navigateByUrl('/dashboard/forms');
  }else{
    // Swal.fire("","We require your most up-to-date licenses to allow you to sell. Please upload through 'Documents' option under your Account.","info")
  }
}
goToResources(){
  if(this.agentIdActive=='true'){
    this.router.navigateByUrl('/dashboard/resources');
  }else{
    // Swal.fire("","We require your most up-to-date licenses to allow you to sell. Please upload through 'Documents' option under your Account.","info")
  }

}
getDashboard() {
  this.user.getDashboardData().pipe()
    .subscribe(
      data => {
        this.leadStatus=data.data.leads.leadStatus;
        if(this.leadStatus == 'Deactivated'){
          this.isDisabled = true;
        } else{
          this.isDisabled = false;
        }
       }, error => {
      }, () => { });
}
}
